import { openBlock as t, createElementBlock as a, createStaticVNode as Ue, defineComponent as W, ref as v, computed as p, normalizeClass as D, createElementVNode as o, createBlock as j, toDisplayString as h, withDirectives as ne, vShow as Se, createCommentVNode as I, inject as be, onMounted as re, onUnmounted as ge, unref as G, withCtx as Z, createVNode as A, Fragment as T, onBeforeUnmount as Me, createTextVNode as Ae, renderSlot as Ve, mergeProps as ue, renderList as S, watch as Fe, withModifiers as Je, nextTick as je, provide as ze, withKeys as Pe } from "vue";
import { OnClickOutside as ie } from "@vueuse/components";
import { B as me } from "./BodyScrollLock.f247d772.js";
import { gsap as b } from "gsap";
import { ScrollTrigger as De } from "gsap/ScrollTrigger";
import { B as Ne, r as ae, s as He, U as Be } from "./UserService.0c09feb8.js";
import Le from "axios";
import { $ as z } from "./FrontiersClibConfigService.5b50b8d0.js";
import { _ as We } from "./_plugin-vue_export-helper.dad06003.js";
import { Avatar as Te } from "../avatar.es.js";
import { useDebounceFn as we } from "@vueuse/core";
import { S as Re } from "./ScrollToPlugin.9e92917a.js";
import '../assets/index.css';function qe(w) {
  const u = "74", n = w.profilePicture;
  return n.endsWith(u) ? n : n.substring(0, n.lastIndexOf("/") + 1) + u;
}
function Ye(w) {
  return w.includes("?") ? w.split("?")[0] : w;
}
class H extends Ne {
  officeSuiteEndpoint() {
    return `https://www.${this.getMainDomain}/api/v3/journals/office`;
  }
  toolsEndpoint() {
    return `https://www.${this.getMainDomain}/api/v3/journals/office/tools`;
  }
  getOfficeSuiteItems() {
    return H.ENABLED_CACHE === !1 || H.cache.office_suite.requestStatus === ae.pending ? this.getOfficeSuiteItemsFromApi() : this.getOfficeSuiteItemsFromCache();
  }
  getOfficeSuiteItemsFromApi() {
    return new Promise((u, n) => {
      H.cache.office_suite.requestStatus = ae.waiting;
      const r = {
        withCredentials: !0
      };
      Le.get(this.officeSuiteEndpoint(), r).then((s) => {
        H.cache.office_suite.data = s.data, u(s.data);
      }).catch((s) => {
        s.code === "401" ? u([]) : n(s.message);
      }).finally(() => {
        H.cache.office_suite.requestStatus = ae.done, setTimeout(this.resetCache, 3e5);
      });
    });
  }
  getOfficeSuiteItemsFromCache(u = 0) {
    return u >= H.cache.office_suite.maxRetries ? this.getOfficeSuiteItemsFromApi() : H.cache.office_suite.requestStatus === ae.waiting ? He(200).then(() => this.getOfficeSuiteItemsFromCache(u + 1)) : new Promise((n, r) => {
      n(H.cache.office_suite.data);
    });
  }
  resetCache() {
    H.cache.office_suite.requestStatus, ae.pending;
  }
  getToolsItems() {
    return new Promise((u, n) => {
      const r = {
        withCredentials: !0
      };
      Le.get(this.toolsEndpoint(), r).then((s) => {
        u(s.data);
      }).catch((s) => {
        s.code === "401" ? u({
          officeSuites: [],
          products: [],
          myTools: []
        }) : n(s.message);
      });
    });
  }
}
const Ke = {}, Ge = {
  class: "Ibar__logo__svg",
  viewBox: "0 0 2811 590",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Qe = /* @__PURE__ */ Ue('<path class="Ibar__logo__text" d="M633.872 234.191h-42.674v-57.246h42.674c0-19.776 2.082-35.389 5.204-48.92 4.164-13.53 9.368-23.939 17.695-31.225 8.326-8.326 18.735-13.53 32.266-16.653 13.531-3.123 29.143-5.204 47.878-5.204h21.858c7.286 0 14.572 1.04 21.857 1.04v62.451c-8.326-1.041-16.653-2.082-23.939-2.082-10.408 0-17.694 1.041-23.939 4.164-6.245 3.122-9.368 10.408-9.368 22.898v13.531h53.083v57.246h-53.083v213.372h-89.512V234.191zM794.161 176.945h86.39v47.879h1.041c6.245-17.694 16.653-30.185 31.225-39.552 14.572-9.368 31.225-13.531 49.96-13.531h10.409c3.122 0 7.286 1.041 10.408 2.082v81.185c-6.245-2.082-11.449-3.122-16.653-4.163-5.204-1.041-11.449-1.041-16.654-1.041-11.449 0-20.816 2.082-29.143 5.204-8.327 3.123-15.613 8.327-20.817 14.572-5.204 6.245-10.408 12.49-12.49 20.817-3.123 8.326-4.163 15.612-4.163 23.939v133.228h-88.472V176.945h-1.041zM989.84 312.254c0-19.776 3.122-39.552 10.41-56.205 7.28-17.695 16.65-32.266 29.14-45.797 12.49-13.531 27.06-22.899 44.76-30.185 17.69-7.285 36.43-11.449 57.24-11.449 20.82 0 39.56 4.164 57.25 11.449 17.69 7.286 32.27 17.695 45.8 30.185 12.49 12.49 22.9 28.102 29.14 45.797 7.29 17.694 10.41 36.429 10.41 56.205 0 20.817-3.12 39.552-10.41 57.246-7.29 17.695-16.65 32.266-29.14 44.756-12.49 12.49-28.11 22.899-45.8 30.185-17.69 7.286-36.43 11.449-57.25 11.449-20.81 0-40.59-4.163-57.24-11.449-17.7-7.286-32.27-17.695-44.76-30.185-12.49-12.49-21.86-28.102-29.14-44.756-7.288-17.694-10.41-36.429-10.41-57.246zm88.47 0c0 8.327 1.04 17.694 3.12 26.021 2.09 9.368 5.21 16.653 9.37 23.939 4.16 7.286 9.37 13.531 16.65 17.695 7.29 4.163 15.62 7.285 26.03 7.285 10.4 0 18.73-2.081 26.02-7.285 7.28-4.164 12.49-10.409 16.65-17.695 4.16-7.286 7.29-15.612 9.37-23.939 2.08-9.368 3.12-17.694 3.12-26.021 0-8.327-1.04-17.694-3.12-26.021-2.08-9.368-5.21-16.653-9.37-23.939-4.16-7.286-9.37-13.531-16.65-17.695-7.29-5.204-15.62-7.285-26.02-7.285-10.41 0-18.74 2.081-26.03 7.285-7.28 5.205-12.49 10.409-16.65 17.695-4.16 7.286-7.28 15.612-9.37 23.939-2.08 9.368-3.12 17.694-3.12 26.021zM1306.25 176.945h86.39v37.47h1.04c4.17-7.286 9.37-13.531 15.62-18.735 6.24-5.204 13.53-10.408 20.81-14.572 7.29-4.163 15.62-7.286 23.94-9.367 8.33-2.082 16.66-3.123 24.98-3.123 22.9 0 40.6 4.164 53.09 11.449 13.53 7.286 22.89 16.654 29.14 27.062 6.24 10.409 10.41 21.858 12.49 34.348 2.08 12.49 2.08 22.898 2.08 33.307v172.779h-88.47V316.417v-27.061c0-9.368-1.04-16.654-4.16-23.94-3.13-7.286-7.29-12.49-13.53-16.653-6.25-4.164-15.62-6.245-27.07-6.245-8.32 0-15.61 2.081-21.85 5.204-6.25 3.122-11.45 7.286-14.58 13.531-4.16 5.204-6.24 11.449-8.32 18.735s-3.12 14.572-3.12 21.858v145.717h-88.48V176.945zM1780.88 234.19h-55.17v122.819c0 10.408 3.12 17.694 8.33 20.817 6.24 3.122 13.53 5.204 22.9 5.204 4.16 0 7.28 0 11.45-1.041h11.45v65.573c-8.33 0-15.62 1.041-23.94 2.082-8.33 1.04-16.66 1.041-23.94 1.041-18.74 0-34.35-2.082-46.84-5.205-12.49-3.122-21.86-8.326-29.14-15.612-7.29-7.286-12.49-16.654-14.58-29.144-3.12-12.49-4.16-27.062-4.16-45.797V234.19h-44.76v-57.246h44.76V94.717h88.47v82.227h55.17v57.246zM1902.66 143.639h-88.48V75.984h88.48v67.655zm-89.52 33.307h88.48v270.618h-88.48V176.946zM2024.43 334.111c1.04 18.735 6.25 33.307 16.66 44.756 10.4 11.449 24.98 16.653 43.71 16.653 10.41 0 20.82-2.081 30.19-7.286 9.36-5.204 16.65-12.49 20.81-22.898h83.27c-4.16 15.613-10.41 29.144-19.78 40.593-9.36 11.449-19.77 20.817-31.22 28.102-12.49 7.286-24.98 12.491-39.55 16.654-14.57 3.122-29.15 5.204-43.72 5.204-21.86 0-41.63-3.122-60.37-9.367-18.73-6.246-34.34-15.613-46.83-28.103-12.49-12.49-22.9-27.062-30.19-45.797-7.28-17.694-10.41-38.511-10.41-60.369 0-20.817 4.17-39.552 11.45-57.246 7.29-17.694 17.7-32.266 31.23-44.756 13.53-12.49 29.14-21.858 46.83-29.144 17.7-7.286 36.43-10.408 56.21-10.408 23.94 0 45.8 4.163 63.49 12.49 17.7 8.327 33.31 19.776 44.76 35.389 11.45 15.612 20.81 32.266 26.02 52.042 5.2 19.776 8.33 41.633 7.28 64.532h-199.84v-1.041zm110.33-49.961c-1.04-15.612-6.24-28.102-15.61-39.551-9.37-10.409-21.86-16.654-37.47-16.654s-28.1 5.204-38.51 15.613c-10.41 10.408-16.66 23.939-18.74 40.592h110.33zM2254.46 176.945h86.39v47.879h1.04c6.25-17.694 16.65-30.185 31.23-39.552 14.57-9.368 31.22-13.531 49.96-13.531h10.4c3.13 0 7.29 1.041 10.41 2.082v81.185c-6.24-2.082-11.45-3.122-16.65-4.163-5.21-1.041-11.45-1.041-16.65-1.041-11.45 0-20.82 2.082-29.15 5.204-8.32 3.123-15.61 8.327-20.81 14.572-6.25 6.245-10.41 12.49-12.49 20.817-3.13 8.326-4.17 15.612-4.17 23.939v133.228h-88.47V176.945h-1.04zM2534.45 359.091c0 7.286 1.04 12.49 4.16 17.694 3.12 5.204 6.24 9.368 10.41 12.49 4.16 3.123 9.36 5.204 14.57 7.286 6.24 2.082 11.45 2.082 17.69 2.082 4.17 0 8.33 0 13.53-2.082 5.21-1.041 9.37-3.123 13.53-5.204 4.17-2.082 7.29-5.204 10.41-9.368 3.13-4.163 4.17-8.327 4.17-13.531 0-5.204-2.09-9.367-5.21-12.49-3.12-3.122-7.28-6.245-11.45-8.327-4.16-2.081-9.36-4.163-14.57-5.204-5.2-1.041-9.37-2.081-13.53-3.122-13.53-3.123-28.1-6.245-42.67-9.368-14.58-3.122-28.11-7.286-40.6-12.49-12.49-6.245-22.9-13.531-30.18-23.939-8.33-10.409-11.45-23.94-11.45-42.675 0-16.653 4.16-30.184 11.45-40.592 8.33-10.409 17.69-18.736 30.18-24.981 12.49-6.245 26.02-10.408 40.6-13.53 14.57-3.123 28.1-4.164 41.63-4.164 14.57 0 29.14 1.041 43.71 4.164 14.58 2.081 27.07 7.285 39.56 13.53 12.49 6.245 21.85 15.613 29.14 27.062 7.29 11.45 11.45 26.021 12.49 43.716h-82.23c0-10.409-4.16-18.736-11.45-23.94-7.28-4.163-16.65-7.286-28.1-7.286-4.16 0-8.32 0-12.49 1.041-4.16 1.041-8.32 1.041-12.49 2.082-4.16 1.041-7.28 3.122-9.37 6.245-2.08 3.122-4.16 6.245-4.16 11.449 0 6.245 3.12 11.449 10.41 15.613 6.24 4.163 14.57 7.286 24.98 10.408 10.41 2.082 20.82 5.204 32.27 7.286 11.44 2.082 22.89 4.163 33.3 6.245 13.53 3.123 24.98 7.286 33.31 13.531 9.37 6.245 15.61 12.49 20.82 19.776 5.2 7.286 9.36 14.572 11.45 21.858 2.08 7.285 3.12 13.53 3.12 19.776 0 17.694-4.17 33.306-11.45 45.796-8.33 12.491-17.7 21.858-30.19 30.185-12.49 7.286-26.02 12.49-41.63 16.653-15.61 3.123-31.22 5.204-45.8 5.204-15.61 0-32.26-1.04-47.87-4.163-15.62-3.122-29.15-8.327-41.64-15.612a83.855 83.855 0 01-30.18-30.185c-8.33-12.49-12.49-28.102-12.49-46.838h84.31v-2.081z" fill="#FFFFFF"></path><path d="M0 481.911V281.028l187.351-58.287v200.882L0 481.911z" fill="#8BC53F"></path><path d="M187.351 423.623V222.741l126.983 87.431v200.882l-126.983-87.431z" fill="#EBD417"></path><path d="M126.982 569.341L0 481.911l187.351-58.287 126.983 87.43-187.352 58.287z" fill="#034EA1"></path><path d="M183.188 212.331l51.001-116.574 65.573 155.085-51.001 116.574-65.573-155.085z" fill="#712E74"></path><path d="M248.761 367.415l51.001-116.574 171.739-28.102-49.96 115.533-172.78 29.143z" fill="#009FD1"></path><path d="M299.762 250.842L234.189 95.757l171.739-28.103 65.573 155.085-171.739 28.103z" fill="#F6921E"></path><path d="M187.352 222.741L59.328 198.802 44.757 71.819 172.78 95.76l14.572 126.982z" fill="#DA2128"></path><path d="M172.78 95.758L44.757 71.818l70.777-70.776 128.023 23.94-70.777 70.776z" fill="#25BCBD"></path><path d="M258.129 153.005l-70.777 69.736-14.571-126.982 70.777-70.778 14.571 128.024z" fill="#00844A"></path>', 10), Xe = [
  Qe
];
function Ze(w, u) {
  return t(), a("svg", Ge, Xe);
}
const xe = /* @__PURE__ */ We(Ke, [["render", Ze]]), et = ["href", "aria-label", "data-event"], tt = ["src", "alt"], ot = { key: 2 }, de = /* @__PURE__ */ W({
  __name: "IbarMainLogo",
  props: {
    tenantLogo: { default: "" }
  },
  setup(w) {
    const u = w, n = v(!1), r = p(() => z.getIsFrontiers), s = p(() => z.getTenantName), c = p(() => z.getWwwAbsoluteUrl("/")), g = p(() => !!(u.tenantLogo && !n.value)), d = () => {
      console.warn(`Error loading tenant logo with url: ${u.tenantLogo}`), n.value = !0;
    };
    return (L, m) => (t(), a("div", {
      class: D(["Ibar__logo", { "Ibar__logo--tenant": !r.value }])
    }, [
      o("a", {
        href: c.value,
        "aria-label": s.value + "home",
        "data-event": L.$ga.getDataEventValue("iBar", "a", "home"),
        class: "Ibar__logo__link"
      }, [
        r.value ? (t(), j(xe, { key: 0 })) : g.value ? (t(), a("img", {
          key: 1,
          src: L.tenantLogo,
          alt: s.value,
          onError: d,
          class: "Ibar__logo__link__tenantLogo"
        }, null, 40, tt)) : (t(), a("span", ot, h(s.value), 1))
      ], 8, et)
    ], 2));
  }
}), at = { class: "Ibar__journal__maskLogo" }, nt = ["src"], rt = { class: "Ibar__journalName" }, lt = { key: 0 }, se = /* @__PURE__ */ W({
  __name: "IbarJournalLogo",
  props: {
    journal: { default: void 0 },
    journalLogo: { default: "" },
    isOpenMenu: { type: Boolean, default: !1 }
  },
  setup(w) {
    const u = w, n = v(!1), r = p(() => u.journal === void 0 ? void 0 : ["Frontiers in", "Frontiers for"].find(
      (m) => u.journal ? u.journal.name.trim().startsWith(m) : ""
    )), s = p(() => {
      if (u.journal !== void 0)
        return r.value ? u.journal.name.trim().substring(r.value.length) : u.journal.name;
    }), c = p(() => z.getIsFrontiers), g = () => {
      n.value = !0;
    };
    return (d, L) => (t(), a("div", {
      class: D(["Ibar__journalName__container", { "Ibar__journalName__container--tenant": !c.value }])
    }, [
      ne(o("div", at, [
        o("img", {
          class: "Ibar__journal__logo",
          onLoad: g,
          src: d.journalLogo
        }, null, 40, nt)
      ], 512), [
        [Se, n.value]
      ]),
      o("div", rt, [
        r.value ? (t(), a("span", lt, h(r.value), 1)) : I("", !0),
        o("span", null, h(s.value), 1)
      ])
    ], 2));
  }
}), st = {
  key: 0,
  class: "Ibar__userArea"
}, ut = ["href", "data-event"], it = /* @__PURE__ */ o("span", null, "Login", -1), ct = [
  it
], dt = { class: "Ibar__userLogged" }, _t = ["data-event"], vt = { class: "Ibar__user__dropdown" }, ft = { class: "Ibar__user__avatar" }, ht = { class: "Ibar__user__name" }, pt = { class: "Ibar__user__email" }, bt = /* @__PURE__ */ o("div", { class: "Ibar__user__separator" }, null, -1), gt = { class: "Ibar__user__list" }, mt = ["href", "data-event"], wt = ["href", "data-event"], It = { key: 0 }, yt = ["href", "data-event"], kt = ["href", "data-event"], Ee = /* @__PURE__ */ W({
  __name: "IbarUser",
  props: {
    helpCenterLink: {}
  },
  emits: ["open", "close"],
  setup(w, { emit: u }) {
    const n = me, r = v(void 0), s = v(!1), c = v(!1), g = v(0), d = v(null), L = be("isOpenToolbarOrUser"), m = p(() => s.value === !1 || r.value === void 0), E = p(() => typeof window > "u" ? "https://www.frontiersin.org/people/login" : `https://www.${z.getMainDomain}/people/login?returnUrl=${encodeURIComponent(location.href)}`), f = p(() => `https://www.${z.getMainDomain}/people/logout`), l = p(() => r.value ? `${z.getLoopUrl}/people/${r.value.id}` : ""), i = p(() => `${z.getLoopUrl}/settings`), y = p(() => {
      if (r.value)
        return qe(r.value);
    }), O = p(() => r.value ? `${r.value.firstName} ${r.value.lastName}` : ""), B = p(() => c.value && g.value <= 568), P = () => {
      d.value && (b.to(d.value, {
        opacity: 0,
        duration: 0.05,
        ease: "Power0.easeNone",
        onComplete: () => {
          c.value = !c.value, Y();
        }
      }), u("open", c.value), L.value = !0);
    }, N = () => {
      d.value && c.value && (b.to(d.value, {
        opacity: 0,
        duration: 0.25,
        ease: "Power0.easeNone",
        onComplete: () => {
          c.value = !1, q();
        }
      }), u("close"), L.value = !1);
    }, R = () => {
      window.innerWidth <= 563 || N();
    }, q = () => {
      d.value && b.to(d.value, {
        opacity: 0,
        duration: 0.4,
        ease: "Power0.easeNone"
      });
    }, Y = () => {
      d.value && b.to(d.value, {
        opacity: 1,
        duration: 0.25,
        ease: "Power0.easeNone"
      });
    }, Q = () => {
      g.value = window.innerWidth;
    }, X = we(() => {
      Q();
    }, 150);
    return typeof window < "u" && new Be().getLoggedUserInfo().then((K) => {
      r.value = K;
    }).catch((K) => {
      console.warn("User API error: ", K);
    }).finally(() => {
      s.value = !0;
    }), re(() => {
      window.addEventListener("resize", X), window.addEventListener("scroll", R), Q();
    }), ge(() => {
      window.removeEventListener("resize", X), window.removeEventListener("scroll", R);
    }), (C, K) => s.value ? m.value ? (t(), a("a", {
      key: 1,
      class: "Ibar__icon Ibar__icon--user",
      href: E.value,
      "aria-label": "Login",
      "data-event": C.$ga.getDataEventValue("iBar", "a", "loginUrl")
    }, ct, 8, ut)) : (t(), j(G(ie), {
      key: 2,
      onTrigger: N
    }, {
      default: Z(() => [
        o("div", dt, [
          o("button", {
            class: "Ibar__userLogged__image",
            onClick: P,
            "aria-label": "User menu",
            "data-event": C.$ga.getDataEventValue("iBar", "btn", ["img", "openUserMenu"])
          }, [
            A(Te, {
              fullName: O.value,
              color: "Grey",
              src: y.value,
              size: "Size32"
            }, null, 8, ["fullName", "src"])
          ], 8, _t),
          ne((t(), a("div", {
            class: "Ibar__user",
            ref_key: "userDropdown",
            ref: d
          }, [
            o("div", vt, [
              o("div", ft, [
                A(Te, {
                  fullName: O.value,
                  color: "Grey",
                  src: y.value
                }, null, 8, ["fullName", "src"])
              ]),
              r.value ? (t(), a(T, { key: 0 }, [
                o("div", ht, h(r.value.firstName) + " " + h(r.value.middleName) + " " + h(r.value.lastName), 1),
                o("div", pt, h(r.value.primaryEmailAddress), 1)
              ], 64)) : I("", !0)
            ]),
            bt,
            o("ul", gt, [
              o("li", null, [
                o("a", {
                  href: l.value,
                  "data-event": C.$ga.getDataEventValue("iBar", "userMenu", ["a", "loopProfile"])
                }, "Loop Profile", 8, mt)
              ]),
              o("li", null, [
                o("a", {
                  href: i.value,
                  "data-event": C.$ga.getDataEventValue("iBar", "userMenu", ["a", "settings"])
                }, "Settings & Privacy", 8, wt)
              ]),
              C.helpCenterLink ? (t(), a("li", It, [
                o("a", {
                  href: C.helpCenterLink.url,
                  "data-event": C.$ga.getDataEventValue("iBar", "userMenu", ["a", "help"])
                }, h(C.helpCenterLink.text), 9, yt)
              ])) : I("", !0),
              o("li", null, [
                o("a", {
                  href: f.value,
                  "data-event": C.$ga.getDataEventValue("iBar", "userMenu", ["a", "logout"])
                }, "Logout", 8, kt)
              ])
            ]),
            o("div", {
              class: "Ibar__user__close",
              onClick: N
            })
          ])), [
            [Se, c.value],
            [
              G(n),
              B.value,
              void 0,
              { noDelay: !0 }
            ]
          ])
        ])
      ]),
      _: 1
    })) : (t(), a("div", st));
  }
});
var Ie = /* @__PURE__ */ ((w) => (w.None = "none", w.ProductHub = "productHub", w))(Ie || {});
const $t = { class: "Ibar__dropdown" }, jt = { class: "Ibar__dropdown__menu__header" }, Oe = 500, ce = /* @__PURE__ */ W({
  __name: "IbarDropdown",
  props: {
    title: { default: "" },
    icon: { default: Ie.None }
  },
  emits: ["close-dropdown"],
  setup(w, { emit: u }) {
    const n = w, r = v(!1), s = v(!1), c = v(null), g = be("isOpenToolbarOrUser"), d = p(() => n.icon !== "none"), L = p(() => {
      const i = ["Ibar__dropdown__trigger__icon"];
      return i.push(`Ibar__dropdown__trigger__icon--${n.icon}`), i;
    }), m = () => {
      setTimeout(() => {
        c.value && c.value.scrollTo(0, 0);
      }, 100);
    }, E = () => {
      s.value || (!r.value && c.value && (c.value.style.display = "block"), setTimeout(() => {
        r.value = !r.value, g.value = r.value, s.value = !0, setTimeout(() => {
          s.value = !1;
        }, Oe), r.value || (m(), setTimeout(() => {
          c.value && (c.value.style.display = "none");
        }, Oe));
      }, 0));
    }, f = () => {
      r.value && (r.value = !1, g.value = !1, m());
    }, l = () => {
      u("close-dropdown"), setTimeout(() => {
        f();
      }, 100);
    };
    return re(() => {
      window.addEventListener("scroll", f);
    }), Me(() => {
      window.removeEventListener("scroll", f);
    }), (i, y) => (t(), j(G(ie), { onTrigger: f }, {
      default: Z(() => [
        o("div", $t, [
          o("button", {
            class: D(["Ibar__dropdown__trigger", {
              "Ibar__dropdown__trigger--open": r.value
            }]),
            onClick: E
          }, [
            d.value ? (t(), a("span", {
              key: 0,
              class: D(L.value)
            }, null, 2)) : I("", !0),
            Ae(" " + h(i.title), 1)
          ], 2),
          o("div", {
            ref_key: "menu",
            ref: c,
            class: D(["Ibar__dropdown__menu", { "Ibar__dropdown__menu--visible": r.value }])
          }, [
            o("div", jt, [
              o("button", {
                class: "Ibar__dropdown__menu__header__title",
                onClick: f,
                "aria-label": "Close Dropdown"
              }, h(i.title), 1),
              o("button", {
                class: "Ibar__close",
                onClick: l,
                "aria-label": "Close Dropdown"
              })
            ]),
            Ve(i.$slots, "default")
          ], 2)
        ])
      ]),
      _: 3
    }));
  }
});
const Dt = { class: "Ibar__dropdown__sections" }, Lt = ["href", "data-event"], _e = /* @__PURE__ */ W({
  __name: "IbarSections",
  props: {
    journal: { default: void 0 },
    section: { default: void 0 },
    sectionTerm: {}
  },
  setup(w) {
    const u = w, n = p(() => {
      if (u.journal)
        return u.journal.sections;
    }), r = (c) => u.journal ? `/journals/${u.journal.slug}/sections/${c}` : "", s = (c) => u.section !== void 0 && c === u.section.slug;
    return (c, g) => (t(), j(ce, ue({ title: c.sectionTerm }, c.$attrs), {
      default: Z(() => [
        o("ul", Dt, [
          (t(!0), a(T, null, S(n.value, (d, L) => (t(), a("li", {
            key: L,
            class: D(["Ibar__dropdown__sections__item", {
              "Ibar__dropdown__sections__item--active": s(d.slug)
            }])
          }, [
            o("a", {
              href: r(d.slug),
              "data-event": c.$ga.getDataEventValue("iBarJournal", "sections", [
                "a",
                "id",
                d.id.toString()
              ])
            }, h(d.name), 9, Lt)
          ], 2))), 128))
        ])
      ]),
      _: 1
    }, 16, ["title"]));
  }
}), Tt = { class: "Ibar__dropdown__about" }, Et = { class: "Ibar__dropdown__about__block__title" }, Ot = ["href", "target", "data-event"], Ce = /* @__PURE__ */ W({
  __name: "IbarAboutUs",
  props: {
    aboutUs: { default: () => [] }
  },
  setup(w) {
    const u = (n) => typeof n == "string" ? n : "";
    return (n, r) => (t(), j(ce, ue({
      title: "About us",
      class: "Ibar__dropdown--aboutUs"
    }, n.$attrs), {
      default: Z(() => [
        o("div", Tt, [
          (t(!0), a(T, null, S(n.aboutUs, (s, c) => (t(), a("ul", {
            class: "Ibar__dropdown__about__block",
            key: c
          }, [
            o("li", Et, h(s.title), 1),
            (t(!0), a(T, null, S(s.links, (g, d) => (t(), a("li", {
              class: "Ibar__dropdown__about__block__item",
              key: d
            }, [
              o("a", {
                href: g.url,
                target: g.target,
                "data-event": n.$ga.getDataEventValue(
                  "iBar",
                  ["aboutUs", c.toString()],
                  ["a", u(s.title)]
                )
              }, h(g.text), 9, Ot)
            ]))), 128))
          ]))), 128))
        ])
      ]),
      _: 1
    }, 16));
  }
}), Ct = { class: "Ibar__dropdown__about" }, St = { class: "Ibar__dropdown__about__block__title" }, Bt = ["href", "target", "data-event"], Ut = { key: 1 }, Mt = ["href", "target", "data-event"], ve = /* @__PURE__ */ W({
  __name: "IbarAboutJournal",
  props: {
    aboutJournal: { default: () => new Array() },
    journal: { default: void 0 },
    section: { default: void 0 },
    offset: { default: 0 },
    aboutJournalText: {}
  },
  emits: ["anchor-click"],
  setup(w, { emit: u }) {
    const n = w;
    b.registerPlugin(Re);
    const r = v(null), s = v(null), c = p(() => {
      if (typeof window > "u")
        return !1;
      const l = location.pathname;
      return !n.journal || !l ? !1 : l.includes(`/journals/${n.journal.slug}/about`);
    }), g = (l) => {
      if (typeof l != "string" && "url" in l)
        return l;
    }, d = (l) => {
      const i = g(l);
      return i ? i.url : "";
    }, L = (l) => {
      const i = g(l);
      return i && i.target ? i.target : "";
    }, m = (l) => {
      const i = g(l);
      return i ? i.text : "";
    }, E = () => {
      !r.value || r.value.length === 0 || r.value.forEach((l) => {
        const i = l;
        i.getAttribute("href").includes("#") && i.addEventListener("click", (B) => {
          s.value && (s.value.toggleOnClick(), u("anchor-click", B));
        });
      });
    }, f = (l) => JSON.stringify(n.aboutJournal).includes(l);
    return re(() => {
      if (typeof window < "u" && c) {
        E();
        const l = Ye(window.location.hash);
        if (l.length === 0 || !document.querySelector(l) || !f(l))
          return;
        setTimeout(() => {
          window.scrollTo(0, 0), l && b.to(window, {
            duration: 0.8,
            scrollTo: {
              y: l,
              offsetY: n.offset
            },
            ease: "Power2.out"
          });
        }, 1);
      }
    }), (l, i) => (t(), j(ce, ue({
      ref_key: "dropdown",
      ref: s,
      title: l.aboutJournalText
    }, l.$attrs), {
      default: Z(() => [
        o("div", Ct, [
          (t(!0), a(T, null, S(l.aboutJournal, (y, O) => (t(), a("ul", {
            class: "Ibar__dropdown__about__block",
            key: O
          }, [
            o("li", St, [
              g(y.title) ? (t(), a("a", {
                key: 0,
                href: d(y.title),
                target: L(y.title),
                "data-event": l.$ga.getDataEventValue(
                  "iBar",
                  ["aboutJournal", O.toString()],
                  ["a", m(y.title)]
                )
              }, h(m(y.title)), 9, Bt)) : (t(), a("span", Ut, h(y.title), 1))
            ]),
            (t(!0), a(T, null, S(y.links, (B, P) => (t(), a("li", {
              class: "Ibar__dropdown__about__block__item",
              key: P
            }, [
              o("a", {
                ref_for: !0,
                ref_key: "anchors",
                ref: r,
                href: B.url,
                target: B.target,
                "data-event": l.$ga.getDataEventValue(
                  "iBar",
                  ["aboutJournal", P.toString()],
                  ["a", B.text]
                )
              }, h(B.text), 9, Mt)
            ]))), 128))
          ]))), 128))
        ])
      ]),
      _: 1
    }, 16, ["title"]));
  }
}), At = {
  key: 0,
  class: "IbarOffice"
}, Vt = ["data-event"], Ft = /* @__PURE__ */ o("span", null, "Office", -1), Jt = [
  Ft
], zt = { class: "Ibar__dropdown__menu__header" }, Pt = ["data-event"], Nt = ["data-event"], Ht = { class: "IbarOffice__dropdown__list" }, Wt = ["href"], Rt = ["onClick", "data-event"], qt = { class: "IbarOffice__dropdown__subitemsList" }, Yt = ["data-event"], Kt = ["href"], Gt = ["href"], Qt = ["onClick", "data-event"], Xt = ["onClick", "data-event"], Zt = ["href"], fe = /* @__PURE__ */ W({
  __name: "IbarOffice",
  props: {
    isDevices: { type: Boolean, default: !1 },
    officeSuiteItems: { default: () => new Array() }
  },
  emits: ["close-dropdown"],
  setup(w, { emit: u }) {
    const n = w, r = me, s = v(!1), c = v(null), g = v(null), d = v(0), L = v(0), m = v(!1), E = v(!1), f = v(null), l = v(null), i = v(null), y = v(null), O = v(null), B = be("isOpenToolbarOrUser"), P = p(() => n.officeSuiteItems.length > 0), N = p(() => s.value && L.value <= 568 && n.isDevices), R = () => {
      if (n.isDevices)
        f.value && b.to(f.value, {
          opacity: s.value ? 1 : 0,
          duration: s.value ? 0.28 : 0.2,
          ease: "Power0.easeOut",
          pointerEvents: s.value ? "all" : "none"
        });
      else {
        if (!f.value || !l.value)
          return;
        f.value.style.display = "block", l.value.style.display = "block";
        const $ = l.value.offsetHeight;
        d.value = $, je(() => {
          s.value ? x(d.value) : (E.value = !1, q()), f.value && b.to(f.value, {
            opacity: s.value ? 1 : 0,
            duration: s.value ? 0.28 : 0.2,
            ease: "Power0.easeOut",
            pointerEvents: s.value ? "all" : "none",
            onComplete: () => {
              !s.value && f.value && l.value && (f.value.style.display = "none", l.value.style.display = "none"), n.isDevices || K();
            }
          });
        });
      }
    }, q = () => {
      setTimeout(() => {
        f.value && f.value.scrollTo(0, 0);
      }, 100);
    }, Y = () => {
      s.value = !1, q();
    }, Q = () => {
      u("close-dropdown"), setTimeout(() => {
        Y();
      }, 100);
    }, X = () => {
      s.value = !s.value, setTimeout(() => {
        R();
      }, 0);
    }, C = () => {
      s.value = !1, setTimeout(() => {
        R();
      }, 0);
    }, K = () => {
      f.value && i.value && (b.set(f.value, {
        height: d.value
      }), b.set([l.value, i.value], {
        xPercent: 0
      }));
    }, te = ($) => {
      c.value = n.officeSuiteItems[$], g.value = $, !n.isDevices && je(() => {
        if (E.value = !1, !l.value || !f.value)
          return;
        const V = l.value.offsetHeight;
        d.value = V;
        const k = 0.28, F = 0.4;
        m.value = !0, b.to(i.value, {
          display: "block",
          duration: 0,
          onComplete: () => {
            if (!i.value)
              return;
            const J = i.value.offsetHeight;
            J > d.value ? b.to(f.value, {
              height: J,
              duration: k,
              onComplete: () => {
                b.to([l.value, i.value], {
                  xPercent: -200,
                  duration: F,
                  onComplete: () => {
                    m.value = !1, !(!l.value || !y.value) && (l.value.style.display = "none", y.value.focus(), setTimeout(() => {
                      x(J);
                    }, 200));
                  }
                });
              }
            }) : b.to([l.value, i.value], {
              xPercent: -200,
              duration: F,
              onComplete: () => {
                m.value = !1, !(!l.value || !y.value) && (l.value.style.display = "none", y.value.focus(), b.fromTo(
                  f.value,
                  {
                    height: d.value
                  },
                  {
                    height: J,
                    duration: k,
                    onComplete: () => {
                      x(J);
                    }
                  }
                ));
              }
            });
          }
        });
      });
    }, x = ($) => {
      const V = window.innerHeight - 64;
      E.value = $ > V;
    }, U = () => {
      if (n.isDevices || !f.value || !l.value || !i.value)
        return;
      E.value = !1;
      const $ = i.value.offsetHeight, V = 0.28, k = 0.4;
      m.value = !0, d.value > $ ? (x(d.value), l.value.style.display = "block", b.to(f.value, {
        height: d.value,
        duration: V,
        onComplete: () => {
          b.to([l.value, i.value], {
            xPercent: 0,
            duration: k,
            onComplete: () => {
              m.value = !1, i.value && (i.value.style.display = "none"), g.value !== null && O.value && O.value[g.value].children[0].focus();
            }
          });
        }
      })) : b.to(l.value, {
        display: "block",
        duration: 0,
        onComplete: () => {
          b.to([l.value, i.value], {
            xPercent: 0,
            duration: k,
            onComplete: () => {
              i.value && (i.value.style.display = "none", x(d.value), b.to(f.value, {
                height: d.value,
                duration: V,
                onComplete: () => {
                  m.value = !1, g.value !== null && O.value && O.value[g.value].children[0].focus();
                }
              }));
            }
          });
        }
      }), q();
    }, ee = () => {
      L.value = window.innerWidth;
    }, le = we(() => {
      ee();
    }, 150);
    return Fe(
      () => s.value,
      () => {
        B.value = s.value;
      }
    ), re(() => {
      window.addEventListener("resize", le), window.addEventListener("scroll", C), ee();
    }), ge(() => {
      window.removeEventListener("resize", le), window.removeEventListener("scroll", C);
    }), ($, V) => (t(), j(G(ie), { onTrigger: C }, {
      default: Z(() => [
        P.value ? (t(), a("div", At, [
          o("button", {
            class: D(["IbarOffice__dropdown__trigger", { "IbarOffice__dropdown__trigger--open": s.value }]),
            onClick: X,
            "aria-label": "User menu",
            "data-event": $.$ga.getDataEventValue("iBar", "btn", "openOfficeMenu")
          }, Jt, 10, Vt),
          $.isDevices ? ne((t(), a("div", {
            key: 0,
            ref_key: "officeDropdown",
            ref: f,
            class: D(["IbarOffice__dropdown", {
              "IbarOffice__dropdown--visible": s.value
            }])
          }, [
            o("div", zt, [
              o("button", {
                "aria-label": "Close Dropdown",
                class: "Ibar__dropdown__menu__header__title",
                onClick: Y,
                "data-event": $.$ga.getDataEventValue("iBar", "btn", "backOfficeMenu")
              }, " Office ", 8, Pt),
              o("button", {
                "aria-label": "Close Dropdown",
                class: "Ibar__close",
                onClick: Q,
                "data-event": $.$ga.getDataEventValue("iBar", "btn", "closeIbar")
              }, null, 8, Nt)
            ]),
            o("ul", Ht, [
              (t(!0), a(T, null, S($.officeSuiteItems, (k, F) => (t(), a("li", {
                class: "IbarOffice__dropdown__item",
                key: F
              }, [
                k.url ? (t(), a("a", {
                  key: 0,
                  href: k.url,
                  class: ""
                }, h(k.label), 9, Wt)) : (t(), a(T, { key: 1 }, [
                  o("button", {
                    onClick: (J) => te(F),
                    class: D({ pointerEventsDisabled: m.value }),
                    "data-event": $.$ga.getDataEventValue("iBar", "btn", "openOfficesSubmenu")
                  }, h(k.label), 11, Rt),
                  o("ul", qt, [
                    o("li", null, [
                      o("button", {
                        onClick: U,
                        class: D({ pointerEventsDisabled: m.value }),
                        "data-event": $.$ga.getDataEventValue(
                          "iBar",
                          "btn",
                          "closeOfficesSubmenu"
                        )
                      }, h(k.label), 11, Yt)
                    ]),
                    (t(!0), a(T, null, S(k.children, (J, oe) => (t(), a("li", {
                      class: "IbarOffice__dropdown__subitem",
                      key: oe
                    }, [
                      o("a", {
                        href: J.url
                      }, h(J.label), 9, Kt)
                    ]))), 128))
                  ])
                ], 64))
              ]))), 128))
            ])
          ], 2)), [
            [
              G(r),
              N.value,
              void 0,
              { noDelay: !0 }
            ]
          ]) : ne((t(), a("div", {
            key: 1,
            ref_key: "officeDropdown",
            ref: f,
            class: D(["IbarOffice__dropdown", {
              "IbarOffice__dropdown--showScrollbar": E.value
            }]),
            "v.lock-scroll-body": "isLockScroll"
          }, [
            o("ul", {
              ref_key: "mainItems",
              ref: l,
              class: "IbarOffice__dropdown__list"
            }, [
              (t(!0), a(T, null, S($.officeSuiteItems, (k, F) => (t(), a("li", {
                class: "IbarOffice__dropdown__item",
                key: F,
                ref_for: !0,
                ref_key: "mainItem",
                ref: O
              }, [
                k.url ? (t(), a("a", {
                  key: 0,
                  href: k.url
                }, h(k.label), 9, Gt)) : (t(), a("button", {
                  key: 1,
                  onClick: (J) => te(F),
                  class: D({ pointerEventsDisabled: m.value }),
                  "data-event": $.$ga.getDataEventValue("iBar", "btn", "openOfficesSubmenu")
                }, h(k.label), 11, Qt))
              ]))), 128))
            ], 512),
            c.value ? (t(), a("ul", {
              key: 0,
              ref_key: "subItems",
              ref: i,
              class: "IbarOffice__dropdown__subitemsList"
            }, [
              o("li", null, [
                o("button", {
                  onClick: Je(U, ["stop"]),
                  ref_key: "goBack",
                  ref: y,
                  class: D({ pointerEventsDisabled: m.value }),
                  "data-event": $.$ga.getDataEventValue("iBar", "btn", "closeOfficesSubmenu")
                }, h(c.value.label), 11, Xt)
              ]),
              (t(!0), a(T, null, S(c.value.children, (k, F) => (t(), a("li", {
                class: "IbarOffice__dropdown__subitem",
                key: F
              }, [
                o("a", {
                  href: k.url
                }, h(k.label), 9, Zt)
              ]))), 128))
            ], 512)) : I("", !0)
          ], 2)), [
            [
              G(r),
              N.value,
              void 0,
              { noDelay: !0 }
            ]
          ])
        ])) : I("", !0)
      ]),
      _: 1
    }));
  }
});
const xt = { class: "Ibar__dropdown__about" }, eo = { class: "Ibar__dropdown__about__block__title" }, to = ["href", "data-event"], oo = {
  key: 0,
  class: "Ibar__dropdown__about__block"
}, ao = /* @__PURE__ */ o("li", { class: "Ibar__dropdown__about__block__title" }, "My tools", -1), no = { class: "Ibar__dropdown__about__block__item__title" }, ro = ["href", "data-event"], lo = {
  key: 0,
  class: "Ibar__button__wrapper"
}, so = ["href", "data-event"], uo = ["href"], io = /* @__PURE__ */ o("span", null, "Back to EOF", -1), co = [
  io
], he = /* @__PURE__ */ W({
  __name: "IbarTools",
  props: {
    toolsDropdown: {}
  },
  setup(w) {
    const u = w, n = p(() => u.toolsDropdown && typeof u.toolsDropdown.impersonatedUserId == "number" && u.toolsDropdown.impersonatedUserId > 0), r = p(() => u.toolsDropdown ? u.toolsDropdown.officeSuites : []), s = p(() => u.toolsDropdown.myTools), c = p(() => r.value.length > 0), g = p(() => s.value.length > 0), d = p(() => u.toolsDropdown.browseAllToolsLink), L = p(() => `https://digital-editorial-office.${z.getMainDomain}/eof/back-to-eof`);
    return (m, E) => c.value && !n.value ? (t(), j(ce, ue({
      key: 0,
      title: "Tools",
      icon: G(Ie).ProductHub,
      class: "Ibar__dropdown--aboutUs"
    }, m.$attrs), {
      default: Z(() => [
        o("div", xt, [
          (t(!0), a(T, null, S(r.value, (f, l) => (t(), a("ul", {
            class: "Ibar__dropdown__about__block",
            key: l
          }, [
            o("li", eo, h(f.label), 1),
            (t(!0), a(T, null, S(f.children, (i, y) => (t(), a("li", {
              class: "Ibar__dropdown__about__block__item",
              key: y
            }, [
              o("a", {
                href: i.url,
                "data-event": m.$ga.getDataEventValue(
                  "iBar",
                  ["tools", l.toString()],
                  ["a", i.url]
                )
              }, h(i.label), 9, to)
            ]))), 128))
          ]))), 128)),
          g.value ? (t(), a("ul", oo, [
            ao,
            (t(!0), a(T, null, S(s.value, (f, l) => (t(), a("li", {
              class: "Ibar__dropdown__about__block__item",
              key: l
            }, [
              o("p", no, h(f.label), 1),
              o("ul", null, [
                (t(!0), a(T, null, S(f.children, (i, y) => (t(), a("li", { key: y }, [
                  o("a", {
                    href: i.url,
                    "data-event": m.$ga.getDataEventValue(
                      "iBar",
                      ["myTools", l.toString()],
                      ["a", i.url]
                    )
                  }, h(i.label), 9, ro)
                ]))), 128))
              ])
            ]))), 128))
          ])) : I("", !0)
        ]),
        d.value ? (t(), a("div", lo, [
          o("a", {
            class: "Ibar__button Ibar__button--toolsLink",
            href: d.value.url,
            "data-event": m.$ga.getDataEventValue("iBarMenu", "a", d.value.text)
          }, h(d.value.text), 9, so)
        ])) : I("", !0)
      ]),
      _: 1
    }, 16, ["icon"])) : n.value ? (t(), a("a", {
      key: 1,
      href: L.value,
      class: "Ibar__icon Ibar__icon--productHub"
    }, co, 8, uo)) : I("", !0);
  }
}), _o = ["href", "aria-label", "data-event"], pe = /* @__PURE__ */ W({
  __name: "IbarMyFrontiers",
  setup(w) {
    const u = v("My Frontiers"), n = v("/my-frontiers/overview");
    return z.getIsFrontiers === !1 && (u.value = "My account"), n.value = z.getWwwAbsoluteUrl(
      "/my-frontiers/overview"
    ), (r, s) => (t(), a("a", {
      class: "Ibar__icon Ibar__icon--list Ibar__myFrontiers",
      href: n.value,
      "aria-label": u.value,
      "data-event": r.$ga.getDataEventValue("iBar", "a", "myFrontiers")
    }, [
      o("span", null, h(u.value), 1)
    ], 8, _o));
  }
}), vo = { class: "Ibar" }, fo = { class: "Ibar__wrapper" }, ho = ["data-event"], po = ["href", "data-event"], bo = ["href", "data-event"], go = ["href", "data-event"], mo = /* @__PURE__ */ o("div", { class: "Ibar__spacer" }, null, -1), wo = ["href", "target", "data-event"], Io = ["onKeydown"], yo = { class: "Ibar__menu__header" }, ko = { class: "Ibar__logo" }, $o = ["data-event"], jo = { class: "Ibar__menu__wrapper" }, Do = {
  key: 0,
  class: "Ibar__menu__journal"
}, Lo = ["href", "data-event"], To = ["href", "target", "data-event"], Eo = ["href", "data-event"], Oo = ["href", "data-event"], Co = { class: "Ibar__wrapper Ibar__wrapper--journal" }, So = ["href", "data-event"], Bo = ["href", "target", "data-event"], Uo = /* @__PURE__ */ o("div", { class: "Ibar__spacer" }, null, -1), Mo = { class: "Ibar__wrapper Ibar__wrapper--journal" }, Ao = ["href", "data-event"], Vo = /* @__PURE__ */ o("div", { class: "Ibar__spacer" }, null, -1), Fo = ["href", "target", "data-event"], Jo = /* @__PURE__ */ o("div", { class: "Ibar__spacer" }, null, -1), zo = ["href", "data-event"], Po = /* @__PURE__ */ o("span", null, "Submit", -1), No = /* @__PURE__ */ o("span", null, " your research", -1), Ho = [
  Po,
  No
], Wo = ["href", "target", "data-event"], ra = /* @__PURE__ */ W({
  __name: "Ibar",
  props: {
    journal: {},
    section: {},
    submitUrl: {},
    searchLink: { default: () => ({
      text: "Search",
      url: "/search",
      target: "_self"
    }) },
    showSubmitButton: { type: Boolean, default: !0 },
    aboutUs: { default: () => [] },
    aboutJournal: { default: () => [] },
    offsetJournalAbout: { default: 0 },
    mainLinks: { default: () => [
      { text: "All journals", url: "/journals" },
      { text: "All articles", url: "/articles" }
    ] },
    journalLinks: { default: () => [] },
    helpCenterLink: {},
    tenantLogo: { default: "" },
    journalLogo: { default: "" },
    aboutJournalText: { default: "About journal" },
    sectionTerm: { default: "Sections" }
  },
  emits: ["about-journal-anchor-click"],
  setup(w, { emit: u }) {
    const n = w;
    b.registerPlugin(De);
    const r = (e) => z.getWwwAbsoluteUrl(e), s = me, c = v(null), g = v(null), d = v(null), L = v(null), m = v(r(n.searchLink.url)), E = v(!1), f = v(void 0), l = v(!1), i = v(!1), y = v([
      { text: "Articles", url: "articles" },
      { text: "Research Topics", url: "research-topics" },
      { text: "Editorial Board", url: "editors" }
    ]), O = v(!1), B = v({}), P = v([]), N = v(!1), R = v(!1);
    ze("isOpenToolbarOrUser", R);
    const q = p(() => n.journal !== void 0 && n.journal.sections !== void 0 && n.journal.sections.length > 0), Y = p(() => n.journal ? n.journal.url ? n.journal.url : r(`/journals/${n.journal.slug}`) : ""), Q = p(() => l.value === !1 || f.value === void 0), X = p(() => i.value && !O.value), C = p(() => n.aboutUs.length > 0), K = (e) => {
      c.value && (c.value.style.zIndex = e ? "" : "50");
    }, te = () => {
      c.value && (c.value.style.zIndex = "");
    }, x = () => {
      E.value = !0;
    }, U = () => {
      const e = E.value ? 100 : 0;
      setTimeout(() => {
        E.value = !1;
      }, e);
    }, ee = () => window.innerWidth > 1024, le = (e) => {
      ee() || e.target !== L.value && U();
    }, $ = (e) => {
      U(), u("about-journal-anchor-click", e);
    }, V = (e) => {
      if (typeof window > "u")
        return { Ibar__link: !0, "": !1 };
      let M = e.url;
      if (e.url.startsWith("http"))
        try {
          const _ = new URL(e.url);
          _ && _.pathname && (M = _.pathname);
        } catch (_) {
          console.warn(_);
        }
      return {
        Ibar__link: !0,
        "Ibar__link--active": location.pathname === M
      };
    }, k = (e) => {
      if (e.url.startsWith("http"))
        return e.url;
      if (!n.journal)
        throw new Error("Journal property is undefined");
      return r(`/journals/${n.journal.slug}/${e.url}`);
    }, F = () => {
      new H().getToolsItems().then((M) => {
        B.value = M, O.value = B.value.enabledOfficeTools || !1, P.value = M.officeSuites;
      }).catch((M) => {
        console.warn(
          "Error trying to retrieve tools dropdown info. Message: ",
          M
        );
      }).finally(() => {
        i.value = !0;
      });
    }, J = () => {
      const e = d.value;
      e && b.set(e, {
        yPercent: -110
      });
    }, oe = () => {
      if (!n.journal)
        return;
      const e = c.value, M = g.value, _ = d.value, ke = () => {
        if (ee()) {
          if (N.value)
            return;
          b.to(e, {
            delay: 0.3,
            duration: 0.35,
            ease: "power1.inOut",
            y: 0
          }), b.to(M, {
            delay: 0.3,
            duration: 0.55,
            ease: "power1.inOut",
            y: 0
          }), b.to(_, {
            duration: 0.5,
            ease: "power3.inOut",
            yPercent: -110
          });
        } else
          b.set(e, {
            y: 0,
            clearProps: "transform"
          });
      };
      De.create({
        trigger: "body",
        start: "top -11",
        end: "top -11",
        markers: !1,
        scrub: !0,
        onEnter: () => {
          parseInt(
            document.body.getAttribute("data-scroll-top") || "0"
          ) > 10 && window.scrollY === 0 || document.body.style.overflow === "hidden" || (ee() ? (N.value = !0, b.to(e, {
            duration: 0.4,
            delay: 0.2,
            ease: "power1.inOut",
            y: -68
          }), b.to(M, {
            duration: 0.6,
            ease: "power1.inOut",
            y: -68 - 56
          }), b.to(_, {
            delay: 0.2,
            duration: 0.6,
            ease: "power3.inOut",
            yPercent: 0,
            visibility: "initial"
          }), setTimeout(() => {
            N.value = !1, !(parseInt(
              document.body.getAttribute("data-scroll-top") || "0"
            ) > 10 && window.scrollY === 0) && window.scrollY < 50 && ke();
          }, 800)) : b.set(e, {
            y: 0,
            clearProps: "transform"
          }));
        },
        onEnterBack: () => {
          parseInt(
            document.body.getAttribute("data-scroll-top") || "0"
          ) > 10 && window.scrollY === 0 || ke();
        },
        onLeaveBack: () => {
          parseInt(
            document.body.getAttribute("data-scroll-top") || "0"
          ) > 10 && window.scrollY === 0 || N.value || ee() && b.to(_, {
            delay: 0.5,
            visibility: "hidden"
          });
        }
      });
    }, ye = we(() => {
      oe();
    }, 150);
    return typeof window < "u" && new Be().getLoggedUserInfo().then((M) => {
      f.value = M, M !== void 0 && F();
    }).catch((M) => {
      console.warn("User API error: ", M);
    }).finally(() => {
      l.value = !0;
    }), n.journalLinks.length > 0 && (y.value = n.journalLinks), re(() => {
      typeof window < "u" && (n.searchLink.url === "/search" && (m.value = r(
        `/search?tab=top-results&origin=${encodeURIComponent(
          location.toString()
        )}`
      )), J(), oe()), oe(), window.addEventListener("resize", ye);
    }), ge(() => {
      window.removeEventListener("resize", ye);
    }), (e, M) => (t(), a("nav", vo, [
      o("div", {
        ref_key: "ibarEl",
        ref: c,
        class: D(["Ibar__main", { "Ibar__main--ddOpen": R.value }])
      }, [
        o("div", fo, [
          o("button", {
            ref_key: "burgerEl",
            ref: L,
            class: "Ibar__burger",
            "aria-label": "Open Menu",
            onClick: x,
            "data-event": e.$ga.getDataEventValue("iBar", "btn", "openMenu")
          }, null, 8, ho),
          A(de, { "tenant-logo": e.tenantLogo }, null, 8, ["tenant-logo"]),
          e.journal ? (t(), a("a", {
            key: 0,
            href: Y.value,
            class: "Ibar__journalName",
            "data-event": e.$ga.getDataEventValue("iBar", "a", "journalHome")
          }, [
            A(se, {
              journal: e.journal,
              journalLogo: e.journalLogo,
              logoClass: "Ibar__logo--mixed"
            }, null, 8, ["journal", "journalLogo"])
          ], 8, po)) : I("", !0),
          C.value ? (t(), j(Ce, {
            key: 1,
            "parent-data-event": "iBar",
            "about-us": e.aboutUs,
            onCloseDropdown: U
          }, null, 8, ["about-us"])) : I("", !0),
          (t(!0), a(T, null, S(e.mainLinks, (_) => (t(), a("a", {
            key: _.text,
            class: D(V(_)),
            href: r(_.url),
            "data-event": e.$ga.getDataEventValue("iBar", "a", _.text)
          }, h(_.text), 11, bo))), 128)),
          e.showSubmitButton && e.submitUrl ? (t(), a("a", {
            key: 2,
            class: "Ibar__button Ibar__submit",
            href: r(e.submitUrl),
            "data-event": e.$ga.getDataEventValue("iBar", "a", "submit")
          }, "Submit your research", 8, go)) : I("", !0),
          mo,
          o("a", {
            class: "Ibar__icon Ibar__icon--search",
            href: m.value,
            "aria-label": "Search",
            target: n.searchLink.target || "_self",
            "data-event": e.$ga.getDataEventValue("iBar", "a", "search")
          }, [
            o("span", null, h(n.searchLink.text), 1)
          ], 8, wo),
          Q.value ? I("", !0) : (t(), j(pe, { key: 3 })),
          O.value ? (t(), j(he, {
            key: 4,
            "tools-dropdown": B.value
          }, null, 8, ["tools-dropdown"])) : I("", !0),
          X.value ? (t(), j(fe, {
            key: 5,
            "office-suite-items": P.value
          }, null, 8, ["office-suite-items"])) : I("", !0),
          A(Ee, {
            "help-center-link": e.helpCenterLink,
            onOpen: K,
            onClose: te
          }, null, 8, ["help-center-link"])
        ])
      ], 2),
      A(G(ie), { onTrigger: le }, {
        default: Z(() => [
          ne((t(), a("div", {
            class: D(["Ibar__menu", {
              "Ibar__menu--open": E.value,
              "Ibar__menu--journal": e.journal
            }]),
            onKeydown: Pe(U, ["esc"])
          }, [
            o("div", yo, [
              o("div", ko, [
                A(de, { "tenant-logo": e.tenantLogo }, null, 8, ["tenant-logo"])
              ]),
              o("button", {
                class: "Ibar__close",
                "aria-label": "Close Menu",
                onClick: U,
                "data-event": e.$ga.getDataEventValue("iBarMenu", "btn", "closeMenu")
              }, null, 8, $o)
            ]),
            o("div", jo, [
              e.journal ? (t(), a("div", Do, [
                o("a", {
                  href: Y.value,
                  "data-event": e.$ga.getDataEventValue("iBarMenu", "a", "journalHome")
                }, [
                  A(se, {
                    journal: e.journal,
                    "journal-logo": e.journalLogo,
                    "is-open-menu": E.value
                  }, null, 8, ["journal", "journal-logo", "is-open-menu"])
                ], 8, Lo),
                q.value ? (t(), j(_e, {
                  key: 0,
                  "parent-data-event": "iBarMenu",
                  journal: e.journal,
                  section: e.section,
                  "section-term": e.sectionTerm,
                  onCloseDropdown: U
                }, null, 8, ["journal", "section", "section-term"])) : I("", !0),
                (t(!0), a(T, null, S(y.value, (_) => (t(), a("a", {
                  key: _.text,
                  class: D(V(_)),
                  href: k(_),
                  target: _.target ? _.target : "_self",
                  "data-event": e.$ga.getDataEventValue("iBar", "a", _.text)
                }, h(_.text), 11, To))), 128)),
                A(ve, {
                  "parent-data-event": "iBarMenu",
                  "about-journal": e.aboutJournal,
                  journal: e.journal,
                  section: e.section,
                  offset: e.offsetJournalAbout,
                  aboutJournalText: e.aboutJournalText,
                  onAnchorClick: $,
                  onCloseDropdown: U
                }, null, 8, ["about-journal", "journal", "section", "offset", "aboutJournalText"])
              ])) : I("", !0),
              C.value ? (t(), j(Ce, {
                key: 1,
                "parent-data-event": "iBarMenu",
                "about-us": e.aboutUs,
                onCloseDropdown: U
              }, null, 8, ["about-us"])) : I("", !0),
              (t(!0), a(T, null, S(e.mainLinks, (_) => (t(), a("a", {
                key: _.text,
                class: D(V(_)),
                href: r(_.url),
                "data-event": e.$ga.getDataEventValue("iBar", "a", _.text)
              }, h(_.text), 11, Eo))), 128)),
              Q.value ? I("", !0) : (t(), j(pe, { key: 2 })),
              O.value ? (t(), j(he, {
                key: 3,
                "tools-dropdown": B.value
              }, null, 8, ["tools-dropdown"])) : I("", !0),
              X.value ? (t(), j(fe, {
                key: 4,
                "is-devices": !0,
                "office-suite-items": P.value,
                onCloseDropdown: U
              }, null, 8, ["office-suite-items"])) : I("", !0),
              e.showSubmitButton && e.submitUrl ? (t(), a("a", {
                key: 5,
                class: "Ibar__button Ibar__submit",
                href: r(e.submitUrl),
                "data-event": e.$ga.getDataEventValue("iBarMenu", "a", "submit")
              }, "Submit your research", 8, Oo)) : I("", !0)
            ])
          ], 42, Io)), [
            [
              G(s),
              E.value,
              void 0,
              { noDelay: !0 }
            ]
          ])
        ]),
        _: 1
      }),
      e.journal ? (t(), a(T, { key: 0 }, [
        o("div", {
          ref_key: "ibarJournalEl",
          ref: g,
          class: D(["Ibar__journal Ibar__journal--main", { "Ibar__journal--ddOpen": R.value }])
        }, [
          o("div", Co, [
            o("a", {
              href: Y.value,
              class: "Ibar__journalName",
              "data-event": e.$ga.getDataEventValue("iBarJournal", "a", "journalHome")
            }, [
              A(se, {
                journal: e.journal,
                "journal-logo": e.journalLogo
              }, null, 8, ["journal", "journal-logo"])
            ], 8, So),
            q.value ? (t(), j(_e, {
              key: 0,
              "parent-data-event": "iBarJournal",
              journal: e.journal,
              section: e.section,
              "section-term": e.sectionTerm,
              onCloseDropdown: U
            }, null, 8, ["journal", "section", "section-term"])) : I("", !0),
            (t(!0), a(T, null, S(y.value, (_) => (t(), a("a", {
              key: _.text,
              class: D(V(_)),
              href: k(_),
              target: _.target ? _.target : "_self",
              "data-event": e.$ga.getDataEventValue("iBar", "a", _.text)
            }, h(_.text), 11, Bo))), 128)),
            A(ve, {
              "parent-data-event": "iBarJournal",
              "about-journal": e.aboutJournal,
              journal: e.journal,
              section: e.section,
              offset: e.offsetJournalAbout,
              aboutJournalText: e.aboutJournalText,
              onAnchorClick: $,
              onCloseDropdown: U
            }, null, 8, ["about-journal", "journal", "section", "offset", "aboutJournalText"]),
            Uo
          ])
        ], 2),
        o("div", {
          ref_key: "ibarMixEl",
          ref: d,
          class: D(["Ibar__journal Ibar__journal--mix", { "Ibar__journal--ddOpen": R.value }])
        }, [
          o("div", Mo, [
            A(de, { "tenant-logo": e.tenantLogo }, null, 8, ["tenant-logo"]),
            o("a", {
              href: Y.value,
              class: "Ibar__journalName",
              "data-event": e.$ga.getDataEventValue("iBarJournal", "a", "journalHome")
            }, [
              A(se, {
                journal: e.journal,
                journalLogo: e.journalLogo,
                logoClass: "Ibar__logo--mixed"
              }, null, 8, ["journal", "journalLogo"])
            ], 8, Ao),
            Vo,
            q.value ? (t(), j(_e, {
              key: 0,
              "parent-data-event": "iBarJournal",
              journal: e.journal,
              section: e.section,
              "section-term": e.sectionTerm,
              onCloseDropdown: U
            }, null, 8, ["journal", "section", "section-term"])) : I("", !0),
            (t(!0), a(T, null, S(y.value, (_) => (t(), a("a", {
              key: _.text,
              class: D(V(_)),
              href: k(_),
              target: _.target ? _.target : "_self",
              "data-event": e.$ga.getDataEventValue("iBar", "a", _.text)
            }, h(_.text), 11, Fo))), 128)),
            A(ve, {
              "parent-data-event": "iBarJournal",
              "about-journal": e.aboutJournal,
              journal: e.journal,
              section: e.section,
              offset: e.offsetJournalAbout,
              aboutJournalText: e.aboutJournalText,
              onAnchorClick: $,
              onCloseDropdown: U
            }, null, 8, ["about-journal", "journal", "section", "offset", "aboutJournalText"]),
            Jo,
            e.showSubmitButton && e.submitUrl ? (t(), a("a", {
              key: 1,
              class: "Ibar__button Ibar__submit",
              href: r(e.submitUrl),
              "data-event": e.$ga.getDataEventValue("iBarJournal", "a", "submit")
            }, Ho, 8, zo)) : I("", !0),
            o("a", {
              class: "Ibar__icon Ibar__icon--search",
              href: m.value,
              "aria-label": "Search",
              target: n.searchLink.target || "_self",
              "data-event": e.$ga.getDataEventValue("iBar", "a", "search")
            }, [
              o("span", null, h(n.searchLink.text), 1)
            ], 8, Wo),
            Q.value ? I("", !0) : (t(), j(pe, { key: 2 })),
            O.value ? (t(), j(he, {
              key: 3,
              "tools-dropdown": B.value
            }, null, 8, ["tools-dropdown"])) : I("", !0),
            X.value ? (t(), j(fe, {
              key: 4,
              "office-suite-items": P.value
            }, null, 8, ["office-suite-items"])) : I("", !0),
            A(Ee, {
              "help-center-link": e.helpCenterLink,
              onOpen: K,
              onClose: te
            }, null, 8, ["help-center-link"])
          ])
        ], 2)
      ], 64)) : I("", !0)
    ]));
  }
});
export {
  H as N,
  ce as _,
  he as a,
  fe as b,
  Ee as c,
  ra as d,
  qe as e,
  Ye as g
};
